export default "__VITE_ASSET__DAJyfcO7__"